module.exports = __webpack_public_path__ + "static/media/LogoEN.0fc255e1.svg";